/**
 * Custom Collection Banner — Read More / Read Less Toggle
 * Handles truncated description on mobile.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var readMoreBtns = document.querySelectorAll('[data-ccb-readmore]');
    var readLessBtns = document.querySelectorAll('[data-ccb-readless]');

    readMoreBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var truncated = this.closest('[data-ccb-truncated]');
        if (!truncated) return;
        var full = truncated.nextElementSibling;
        if (!full) return;

        truncated.classList.remove('is-show');
        truncated.classList.add('is-hidden');
        full.classList.remove('is-hidden');
        full.classList.add('is-show');
      });
    });

    readLessBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = this.closest('[data-ccb-full]');
        if (!full) return;
        var truncated = full.previousElementSibling;
        if (!truncated) return;

        full.classList.remove('is-show');
        full.classList.add('is-hidden');
        truncated.classList.remove('is-hidden');
        truncated.classList.add('is-show');
      });
    });
  });
})();
